import { useEffect, useState } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

const STORAGE_KEY = "medication_frequency_filter_state";

interface Props {
  storageKey?: string;
}
export function useMedicationFrequencyFilter(options?: Props) {
  const [frequencies, setFrequencies] = useState<string[]>([]);

  useEffect(() => {
    loadFrequencyFilters();
  }, []);

  const loadFrequencyFilters = async () => {
    try {
      const stored = await AsyncStorage.getItem(
        options?.storageKey ?? STORAGE_KEY,
      );
      if (stored) {
        const parsed = JSON.parse(stored);
        if (
          Array.isArray(parsed) &&
          parsed.every((v) => typeof v === "string")
        ) {
          setFrequencies(parsed);
        }
      }
    } catch (e) {
      console.error("Error loading frequency filters:", e);
    }
  };

  const handleFrequencyChange = async (newFrequencies: string[]) => {
    setFrequencies(newFrequencies);
    try {
      await AsyncStorage.setItem(
        options?.storageKey ?? STORAGE_KEY,
        JSON.stringify(newFrequencies),
      );
    } catch (e) {
      console.error("Error saving frequency filters:", e);
    }
  };

  return {
    frequencies,
    handleFrequencyChange,
    loadFrequencyFilters,
  };
}
